export const branchTypeLabels: Record<string, string> = {
  branch: 'page.map.branch_badges.branch',
  savings_bank: 'page.map.branch_badges.savings_bank',
  atm: 'page.map.branch_badges.atm',
  terminal: 'page.map.branch_badges.terminal',
  exchange: 'page.map.branch_badges.exchange'
}

export const organizationTypeLabels: Record<string, string> = {
  bank: 'common.banks',
  microcredit_company: 'common.microcredits',
  insurance_company: 'common.insurance_companies',
  money_transfer_company: 'entity.branch.mocks.organization_types.money_transfer_company',
  crypto_company: 'entity.branch.mocks.organization_types.crypto_company',
  exchange_office: 'common.exchange_offices'
}

export const serviceLabels: Record<string, string> = {
  deposits: 'common.deposits',
  credits: 'common.credits',
  micro_credits: 'common.microcredits',
  credit_cards: 'common.credit_cards',
  debit_cards: 'common.debit_cards',
  insurance: 'common.insurance',
  partners_atms: 'entity.branch.mocks.services.partners_atms',
  'cash-in': 'entity.branch.mocks.services.cash_in',
  withdrawal: 'entity.branch.mocks.services.withdrawal',
  crypto: 'entity.branch.mocks.services.crypto',
  'all-day': 'entity.branch.mocks.services.all_day'
}

export const serviceIcons: Record<string, string> = {
  deposits: 'PiggyBank',
  credits: 'HandCoins',
  micro_credits: 'Coins',
  credit_cards: 'CreditCard',
  debit_cards: 'CreditCard',
  insurance: 'Shield',
  partners_atms: 'Landmark',
  'cash-in': 'ArrowDownToLine',
  withdrawal: 'ArrowUpFromLine',
  crypto: 'Bitcoin',
  'all-day': 'Clock'
}

export default {
  branchTypeLabels,
  organizationTypeLabels,
  serviceLabels,
  serviceIcons
}
